/**
 * Where the platform recogniser's spoken languages are added: System Settings
 * → Keyboard (its Dictation section) on macOS, Settings → Time & language →
 * Speech on Windows. Whisper needs neither - every language is built in.
 *
 * The Settings language list re-reads on window focus, so a language added
 * there appears as soon as the user comes back.
 */
import { isWindowsPlatform } from "@/lib/os-platform";
import { openDictationSettings } from "./onboarding/permissions-deep-links";
import { openWindowsSpeechSettings } from "./windows-speech-settings";

export async function openSpokenLanguageSettings(): Promise<void> {
  if (isWindowsPlatform()) {
    await openWindowsSpeechSettings();
    return;
  }
  await openDictationSettings();
}
